export const parseGradientColor = (color: string) => {
  const matches = color.match(/\((.*)?\)/);

  if (!matches) {
    throw new Error('Invalid gradient');
  }

  const [angle, ...pairs] = matches[1].split(/,\s*/);

  return {
    angle: Number(angle.split('deg')[0]),
    ...pairs.reduce<{ colors: string[]; locations: number[] }>(
      (accumulator, pair) => {
        const [color, percent] = pair.split(/\s+/);

        accumulator.colors.push(color);

        if (percent) {
          const location = Number(percent.split('%')[0]) / 100;

          accumulator.locations.push(Math.max(0, Math.min(location, 1)));
        }

        return accumulator;
      },
      {
        colors: [],
        locations: [],
      },
    ),
  };
};

export const getGradientDirection = (isHorizontal?: boolean) =>
  isHorizontal
    ? {
        start: { x: 0, y: 0 },
        end: { x: 1, y: 0 },
      }
    : {
        start: { x: 0, y: 0 },
        end: { x: 0, y: 1 },
      };

export const parseCssGradientToSvg = (gradientString: string) => {
  const { angle, colors, locations } = parseGradientColor(gradientString);

  // Convert angle to SVG coordinates
  const radians = (angle * Math.PI) / 180;
  const x = Math.cos(radians);
  const y = Math.sin(radians);

  const coords = {
    x1: `${Math.round((50 - x * 50) * 100) / 100}%`,
    y1: `${Math.round((50 - y * 50) * 100) / 100}%`,
    x2: `${Math.round((50 + x * 50) * 100) / 100}%`,
    y2: `${Math.round((50 + y * 50) * 100) / 100}%`,
  };

  // Convert to SVG stops format
  const stops = colors.map((color, index) => ({
    offset: locations[index]
      ? `${locations[index] * 100}%`
      : `${(index / (colors.length - 1)) * 100}%`,
    stopColor: color,
  }));

  return {
    ...coords,
    stops,
    angle,
  };
};
